import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class FalconersTower2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FALCONERS_TOWER2;
}

export default FalconersTower2PoiTileEntity;
